export const GoalCount = (props) => {
    return (
        <div className="w-2/5 aspect-square flex justify-center items-center m-0.5" style={{backgroundColor: props.colour}}>
            <p className="text-xl">{props.count}</p>
        </div>
    )
}